import { ActionButtons, type ActionButtonsProps } from '@/presentation/components/ActionButtons';

type MobileActionBarProps = Omit<ActionButtonsProps, 'variant'>;

/**
 * スマートフォン幅でだけ出る生成バー。
 * 左パネルの「生成」節は lg 未満で隠れ、その役目をここが引き受ける。
 * 判定と操作は ActionButtons の bar 版に委ね、この層は置き場所だけを決める。
 */
export function MobileActionBar(props: MobileActionBarProps) {
  return (
    <div className="mobile-action-bar lg:hidden">
      <ActionButtons variant="bar" {...props} />
    </div>
  );
}
